<template>
    <div v-loading="loading" element-loading-text="请稍等···">
        <div class="margin-20">
            <FilterPageList ref="pageListRef" :data="userList" :total="total" :order-by="orderBy" :filters="filters">
                <template slot-scope="scope">
                    <el-form :inline="true" class="table-filter">
                        <input type="text" v-show="false"/>
                        <el-form-item label="">
                            <el-input placeholder="请输入用户名" v-model="backFilter.userName" @keyup.enter.native="getUsersReq"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="getUsersReq">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="page-table">
                        <div class="page-table-header">
                            <div class="page-table-header-title"><i class="fa fa-list"></i>用户列表
                                <el-button type="text" @click="getUsersReq"><i class="fa fa-refresh"></i></el-button>
                            </div>
                            <div class="pull-right">
                                <!--<el-button @click="handleAdd()"><i class="fa fa-plus-circle text-btn"></i>添加权限集</el-button>-->
                            </div>
                        </div>
                        <el-table stripe border @sort-change="scope.onSortChange" :data="scope.pageData" style="width: 100%">
                            <el-table-column prop="userName" label="用户名"></el-table-column>
                            <el-table-column prop="authenticationKey" label="动态秘钥"></el-table-column>
                            <el-table-column prop="createdBy" label="创建者"></el-table-column>
                            <el-table-column prop="createTime" label="创建时间" >
                                <template slot-scope="scope">
                                    {{scope.row.createTime | formatDate}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="lastUpdateTime" label="更新时间">
                                <template slot-scope="scope">
                                    {{scope.row.lastUpdateTime | formatDate}}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100px" align="center">
                                <template slot-scope="scope">
                                    <!--<el-tooltip content="编辑" placement="top">-->
                                        <!--<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)"></el-button>-->
                                    <!--</el-tooltip>-->
                                    <el-tooltip content="重置动态秘钥" placement="top">
                                        <el-button type="text" icon="el-icon-edit" @click="handleResetAuthenticationKey(scope.row)"></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="重置密码" placement="top">
                                        <el-button type="text" icon="el-icon-refresh" @click="handleReset(scope.row)"></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="删除" placement="top">
                                        <el-button type="text" icon="el-icon-delete text-danger" @click="handleDelete(scope.row)"></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
            </FilterPageList>
        </div>
    </div>
</template>
<script>

export default {
  data() {
    return {
      loading: false,
      userList: [],
      total: 0,
      filters: {},
      backFilter: {
        userName: null,
        roleKey: null,
        namespace: null,
      },
      orderBy: '',
    };
  },
  methods: {
    createStateFilter(queryString) {
      return state =>
        state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
    },
    handleDelete(row) {
      this.$message.confirmMessage(`确认删除用户 ${row.userName} 吗?`, () => {
        const params = {
          userName: row.userName,
        };
        this.$http.post('/console/userManage/deleteUser', params).then(() => {
          this.getUsersReq();
          this.$message.successNotify('删除用户操作成功');
        })
        .catch(() => { this.$http.buildErrorHandler('删除用户请求失败！'); });
      });
    },
    handleReset(row) {
      this.$message.confirmMessage(`确认重置用户 ${row.userName} 的密码吗?`, () => {
        const params = {
          userName: row.userName,
        };
        this.$http.post('/console/userManage/resetUserPass', params).then(() => {
          this.getUsersReq();
          this.$message.successNotify('重置用户密码操作成功，重置后密码为 "123456"');
        })
        .catch(() => { this.$http.buildErrorHandler('重置用户密码请求失败！'); });
      });
    },
    handleResetAuthenticationKey(row) {
      this.$message.confirmMessage(`确认重置用户 ${row.userName} 的动态秘钥吗?`, () => {
        const params = {
          userName: row.userName,
        };
        this.$http.post('/console/userManage/handleResetAuthenticationKey', params).then(() => {
          this.getUsersReq();
          this.$message.successNotify('重置用户动态秘钥操作成功');
        })
        .catch(() => { this.$http.buildErrorHandler('重置用户动态秘钥请求失败！'); });
      });
    },

    getUsersReq() {
      const params = {
        userName: this.backFilter.userName !== '' ? this.backFilter.userName : null,
      };
      this.loading = true;
      this.$http.get('/console/userManage/getUsers', params).then((data) => {
        this.userList = data;
      })
      .catch(() => { this.$http.buildErrorHandler('获取用户列表请求失败！'); })
      .finally(() => {
        this.loading = false;
      });
    },
  },
  computed: {
  },
  components: {
    // 'user-info-dialog': userInfoDialog,
  },
  created() {
    this.getUsersReq();
  },
};
</script>
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// user_manage.vue?58265a8c